import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { useStructuredSearchStore } from "@/components/StructuredSearch";

export const useStructuredSearchActiveEffect = (
  onSearchActiveChange?: (isActive: boolean) => void,
) => {
  const structuredSearchStore = useStructuredSearchStore();
  const isSearchActive =
    structuredSearchStore.dropdownOpen ||
    structuredSearchStore.editingFilterId !== null ||
    structuredSearchStore.step !== "idle";

  useEffect(() => {
    onSearchActiveChange?.(isSearchActive);
  }, [isSearchActive, onSearchActiveChange]);

  useEffect(
    () => () => {
      onSearchActiveChange?.(false);
    },
    [onSearchActiveChange],
  );
};

export const StructuredSearchActiveEffect = observer(
  ({ onSearchActiveChange }: { onSearchActiveChange?: (isActive: boolean) => void }) => {
    useStructuredSearchActiveEffect(onSearchActiveChange);
    return null;
  },
);
